import { combineReducers } from 'redux'
import { ERROR_SET, ERROR_CLEAR, ERROR_CLEAR_ALL, SET, CLEAR } from './action-types'
import { transformState } from '../utils/calculations'
/// / hard coded state info relative to selected / available states.
const stateAndAssociatedUrls = [
  {
    state: 'Kentucky',
    abbreviation: 'KY',
    url: 'https://www.kyfb.com',
    tier: 'Kentucky Farm Bureau Insurance'
  },
  {
    state: 'Texas',
    abbreviation: 'TX',
    url: 'https://www.txfb-ins.com',
    tier: 'Texas Farm Bureau insurance'
  },
  {
    state: 'Louisiana',
    abbreviation: 'LA',
    url: 'https://www.lafarmbureau.com',
    tier: 'Louisiana Farm Bureau Insurance'
  },
  {
    state: 'Colorado',
    abbreviation: 'CO',
    url: 'https://www.cfbinsurance.com',
    tier: 'Colorado Farm Bureau Insurance'
  },
  {
    state: 'Arkansas',
    abbreviation: 'AR',
    url: 'https://www.afbic.com',
    tier: 'Arkansas Farm Bureau Insurance'
  },
  {
    state: 'Mississippi',
    abbreviation: 'MS',
    url: 'https://www.msfbins.com',
    tier: 'Mississippi Farm Bureau Insurance'
  },
  {
    state: 'Virginia',
    abbreviation: 'VA',
    url: 'https://www.vafb.com',
    tier: 'Virginia Farm Bureau Insurance'
  },
  {
    state: 'North Carolina',
    abbreviation: 'NC',
    url: 'https://www.ncfbins.com',
    tier: 'North Carolina Farm Bureau Insurance'
  },
  {
    state: 'South Carolina',
    abbreviation: 'SC',
    url: 'https://www.scfbins.com',
    tier: 'South Carolina Farm Bureau Insurance'
  },
  {
    state: 'Georgia',
    abbreviation: 'GA',
    url: 'https://www.gfbinsurance.com',
    tier: 'Georgia Farm Bureau Insurance'
  },
  {
    state: 'Florida',
    abbreviation: 'FL',
    url: 'https://www.floridafarmbureau.com',
    tier: 'Florida Farm Bureau Insurance'
  }
]

const appInitialState = {
  step: 0,
  state: '',
  zip: '',
  age: 0,
  gender: 'male',
  numOfChildren: 0,
  youngestChildAge: 0,
  currentLifeInsurance: 2500000,
  finalExpenses: 25000,
  mortgage: 500000,
  personalBusinessDebt: 1000000,
  annualCostOfEducation: 20000,
  netAnnualIncome: 100000,
  yearsToProvide: 4,
  yearsOfIncomeAfterDeath: 0, // TODO: The range should automatically default to 18 minus the youngest child’s age (18 – youngest child’s age = where range falls)
  workingWithAgentName: '',
  emailAddress: '',
  emailMessage: '',
  phoneNo: '',
  firstName: '',
  lastName: '',
  generatedPdfFilename: '',
  pageIndex: 0,
  estimate: 0,
  city: '',
  address: '',
  dateOfBirth: ''
}

export const getSelectedStateInfo = (stateName) => {
  const emptyState = { state: '', url: '', tier: '' }
  if (!stateName) return emptyState
  return stateAndAssociatedUrls.find(obj => obj.abbreviation.toLowerCase() === stateName.toLowerCase())
}

function app (state = appInitialState, action) {
  switch (action.type) {
    case SET:
      return transformState(action.payload, state)
    case CLEAR:
      return { ...appInitialState }
    default:
      return state
  }
}

function errors (state = {}, action) {
  switch (action.type) {
    case ERROR_SET:
      return { ...state, authError: action.payload }
    case ERROR_CLEAR:
      return { ...state, [action.payload]: null }
    case ERROR_CLEAR_ALL:
      return {}
    default:
      return state
  }
}

export default () => {
  return combineReducers({
    app, errors
  })
}
